import styled, { css } from 'styled-components';

function generateProperties() {
  return css`
    ${({ properties = [] } = {}) => properties.map(property => `
      ${Object.keys(property)[0]}: ${Object.values(property)[0]};
    `)}
  `;
}

export default function StyledComponent(Component) {
  return styled(Component)`
    ${generateProperties};
  `;
}
